import { openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = ["disabled"];
const _hoisted_2 = {
    key: 0,
    class: "spinner-border spinner-border-sm",
    role: "status",
    "aria-hidden": "true"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = ["disabled"];
const _hoisted_5 = {
    key: 0,
    class: "spinner-border spinner-border-sm",
    role: "status",
    "aria-hidden": "true"
};
const _hoisted_6 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.action !== 'click')
        ? (_openBlock(), _createElementBlock("button", _mergeProps({ key: 0 }, _ctx.$attrs, {
            class: ['btn', _ctx.cssClass, _ctx.cssStyle],
            disabled: _ctx.disabled || _ctx.isLoading,
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.OnClickInternal && _ctx.OnClickInternal(...args)))
        }), [
            (_ctx.isLoadingInternal)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.text), 1))
        ], 16, _hoisted_1))
        : (_openBlock(), _createElementBlock("button", _mergeProps({ key: 1 }, _ctx.$attrs, {
            class: ['btn', _ctx.cssClass, _ctx.cssStyle],
            disabled: _ctx.disabled || _ctx.isLoading
        }), [
            (_ctx.isLoadingInternal)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.text), 1))
        ], 16, _hoisted_4));
}
